module.exports = __webpack_public_path__ + "22a97971fe24cbf79171d36ca0925012.webp";